import React, { useRef, useState } from 'react';
import './product-nearby-store-list-detail.scss';
import '../message/message.scss';
import { postMessageToClient } from '../chatservice/communicationService';
import { config } from '../../config/config.env';

type ProductNearbyStoreListDetailProps = {
    nearbyStore: any,
    isHostDevice: any,
    toggleWidget: any
}

const formatStoreName = (storeName: any) => {
    const store = storeName.replaceAll("BWS ", "");
    return store.charAt(0).toUpperCase() + store.slice(1).toLowerCase();
}

const getPackType = (product:any) =>{
    return product.availablePackTypes.sort((a: any, b: any) => a.UnitQty > b.UnitQty ? 1 : -1)[0];
}


const getInventoryStatus = (product: any, nearbyStore:any) => {
    return `${nearbyStore?.storeAvailableQuantity} at ${formatStoreName(nearbyStore?.storeName)}`;
}

const ProductNearbyStoreListDetail = ({ nearbyStore, toggleWidget, isHostDevice }: ProductNearbyStoreListDetailProps) => {
   let product = nearbyStore.product;
   let stockText = getInventoryStatus(product,nearbyStore);
   const [isDelivery, setIsDelivery] = useState<boolean>(
    nearbyStore.facilities.includes("SYS- Express Delivery")
  );
  const [isPickup, setIsPickup] = useState<boolean>(
    nearbyStore.facilities.includes("SYS- BWS Collect")
  );
  const [isDriveThrough, setIsDriveThrough] = useState(
    nearbyStore.facilities.includes("Drive Thru")
  );

   const onClickHandler = (e: any) => {


        const analyticsCall = {
            data: {
                linkName: `web:chatbot:product availability:find nearby:purchase from store:${nearbyStore.storeName}`,
                linkType: 'chatbot product availability',
            },
            methodHandler: "chatbotTriggerAdobeAnalytics"
        };
        postMessageToClient(analyticsCall);

        // init change url
        const objCall = {
            data: {
                prodDetailsUrl: product.productDetailsUrl,
                storeId: nearbyStore.storeNo,
                storeName: formatStoreName(nearbyStore.storeName),
                queryString: { i_cid: 'cbprodavail-findnearby' }
            },
            methodHandler: "chatbotInitChangeUrl"
        };

    //minimize widget
    toggleWidget(false);
    postMessageToClient(objCall);
}

return (
    <div className='storeNearBy'>
        <div className='storeNearBy__location'>
                <div className='storeStock__title'>BWS <span className='storeStock__suburb'>{nearbyStore.suburb.toLowerCase()}</span></div>
                      {nearbyStore.distance && <div className='storeStock__address storeStock__distance'>{nearbyStore.distance} km</div>}
        </div>
        <div className="storeNearBy__inventory">
            <span>{nearbyStore.storeAvailableQuantity} units available</span>
        </div>

        <div className="storeStock__facilities">
                    {isDelivery ? (
                        <div className="delivery">
                            <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />  
                            <span> Delivery</span>
                        </div>
                    ) : (
                        ""
                    )}
                    {isPickup ? (
                        <div className="pickUp">
                            <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />                            
                            <span> Pick up</span>
                        </div>
                    ) : (
                        ""
                    )}

                    {isDriveThrough ? (
                        <div className="driveThrough">
                            <img className="product__facilities-isAvailable" src="/images/Vector-correct.svg" alt="" />                            
                            <span> Drive through</span>
                        </div>
                    ) : (
                        ""
                    )}
                </div>

        <div className="storeNearBy__address">
            <span>{nearbyStore.addressLine1}, {nearbyStore.state} {nearbyStore.postcode}</span>    
        </div>
        <div className="storeNearBy__todayStatus">
            <span className='storeNearBy__todayStatus--openToday' >Open {nearbyStore.tradingHours[0].Day}</span>
            <span className='storeNearBy__todayStatus--closeTime'>-</span> 
            <span className='storeNearBy__todayStatus--closeTime'>closes at {nearbyStore.tradingHours[0].OpenHour.split('-')[1]}</span>
        </div>

        {
        (config.ISWEBVIEW === false) &&
        <div className="message__text--qr storeNearBy__button">
            <a className="message__text--click" tabIndex={2} onClick={onClickHandler} id="purchase-from-link">
                <span>Buy from This Store</span>
                <img src="/images/Vector-link-icon.svg" alt="" />{" "}
            </a>
        </div>
        }
    </div>
);
}

export {
    ProductNearbyStoreListDetail
}